/**
 * https://artof.pro © 2020
 * Supports ES6 syntax
 **/

import $ from 'jquery';
import 'owl.carousel';

$(document).ready(function () {
  if ($('#homeSlider').length) {
    $('#homeSlider').owlCarousel({
      items: 1,
      loop: true,
      margin: 0,
      autoplay: true
    });
  }

  // Menu products

  if ($('.products-menu').length) {
    const setProductsCarousel = () => {
      if ($(window).width() < 992) {
        $(".products-menu").addClass('owl-carousel');
        $(".products-menu").owlCarousel({
          items: 1,
          loop: false,
          margin: 0,
          dotsEach: 1,
          responsive: {
            0: {
              items: 1,
              margin: 0,
            },
            768: {
              items: 2,
              margin: 20,
            }
          }
        });
      } else {
        $(".products-menu").removeClass('owl-carousel');
        $(".products-menu").owlCarousel('destroy');
      }
    }

    setProductsCarousel();

    $(window).on('resize', function () {
      setProductsCarousel();
    });
  }
});
